<div class="spacer">
  <p-panel>
    <div class="grid">
      <div class="col-12">
        <p-header class="sub-section-header">Reports Input</p-header>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <span class="content-label">
            Periods:
            <span class="required" *ngIf="this.calendarReportSelected || this.baseLineReportSelected 
                      || this.transporterReportSelected || this.partSupppDockReportSelected">*</span>
          </span>
          <p-select class="is-dropdown" placeholder=" " [options]="periods" name="selectedPeriod"
            [(ngModel)]="selectedPeriod" [dropdownIcon]="'fa fa-chevron-down'">
          </p-select>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3" *ngIf="this.isNamcSelected">
        <div class="stacked-content">
          <span class="content-label">
            NAMCs:
            <span class="required" *ngIf="(this.calendarReportSelected || this.baseLineReportSelected 
                      || this.transporterReportSelected || this.partSupppDockReportSelected)">*</span>
          </span>
          <p-multiSelect class="is-dropdown" [options]="namcs" name="selectedNamcs" [(ngModel)]="selectedNamcs"
            [filter]="true" (onChange)="onChangeNamc($event)" [dropdownIcon]="'fa fa-chevron-down'">
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3" *ngIf="this.isDomicileSelected">
        <div class="stacked-content">
          <span class="content-label">
            Domiciles:
            <span class="required" *ngIf="(this.calendarReportSelected || this.baseLineReportSelected 
                      || this.transporterReportSelected || this.partSupppDockReportSelected)">*</span>
          </span>
          <p-multiSelect class="is-dropdown" [options]="domiciles" name="selectedDomiciles"
            [(ngModel)]="selectedDomiciles" [filter]="true" (onChange)="onChangeDomicile($event)"
            [dropdownIcon]="'fa fa-chevron-down'">
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <span class="content-label">
            Fiscal Year:
            <span class="required" *ngIf="this.calendarReportSelected || this.transporterReportSelected || this.partSupppDockReportSelected || 
                      this.crossDockReportSelected">*</span> <!--  || this.baseLineReportSelected-->
          </span>
          <p-select class="is-dropdown" placeholder=" " [options]="fiscalYears" name="fiscalYears"
            [(ngModel)]="fiscalYear" [dropdownIcon]="'fa fa-chevron-down'">
          </p-select>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3" *ngIf="this.baseLineReportSelected">
        <div class="stacked-content">
          <span class="content-label">
            Design Pattern:
            <span class="required">*</span>
          </span>
          <p-select class="is-dropdown" placeholder=" " [options]="designPatterns" name="designPatterns"
            [(ngModel)]="designPattern" [dropdownIcon]="'fa fa-chevron-down'">
          </p-select>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-9" *ngIf="this.baseLineReportSelected"></div>

      <div class="col-12 md:col-6 lg:col-12">
        <div *ngIf="selectedNamcs?.length > 0" class="stacked-content">
          <b>Selected NAMCs:</b> {{ selectedNamcsString() }}
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-12">
        <div *ngIf="selectedDomiciles?.length > 0" class="stacked-content">
          <b>Selected Domiciles:</b> {{ selectedDomicilesString() }}
        </div>
      </div>     

      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <p-checkbox name="alloReports" value="dock" label="Dock" [(ngModel)]="selectedReports"></p-checkbox>
          <label for="dock" class="checkbox-label">Dock</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <p-checkbox name="alloReports" value="plant" label="Plant" [(ngModel)]="selectedReports"></p-checkbox>
          <label for="plant" class="checkbox-label">Plant</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <p-checkbox name="alloReports" value="supplier" label="Supplier" [(ngModel)]="selectedReports"></p-checkbox>
          <label for="supplier" class="checkbox-label">Supplier</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <p-checkbox name="alloReports" value="crossDock" label="CrossDock" [(ngModel)]="selectedReports"
            (onChange)="onChangeCrossDockReport($event)"></p-checkbox>
            <label for="crossDock" class="checkbox-label">CrossDock</label>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <p-checkbox name="alloReports" value="calendar" label="Calendar" [(ngModel)]="selectedReports"
            (onChange)="onChangeCalReport($event)"></p-checkbox>
            <label for="calendar" class="checkbox-label">Calendar</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <p-checkbox name="alloReports" value="baselineRoute" label="Baseline Route" [(ngModel)]="selectedReports"
            (onChange)="onChangeBaselineReport($event)">
          </p-checkbox>
          <label for="baselineRoute" class="checkbox-label">Baseline Route</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <p-checkbox name="alloReports" value="transRate" label="Transporter Rate" [(ngModel)]="selectedReports"
            (onChange)="onChangeTransReport($event)">
          </p-checkbox>
          <label for="transRate" class="checkbox-label">Transporter Rate</label>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-3">
        <div class="stacked-content">
          <p-checkbox name="alloReports" value="partSuppDock" label="Part Supplier Dock" [(ngModel)]="selectedReports"
            (onChange)="onChangePartsSuppDockReport($event)">
          </p-checkbox>
          <label for="partSuppDock" class="checkbox-label">Part Supplier Dock</label>
        </div>
      </div>

      <div class="col-12 md:col-6 lg:col-12">
        <div class="content-end">
          <button name="Generate Reports" pButton type="button" label="Generate Report(s)" (click)="generateReports()"
            class="button primary p-button-rounded">
          </button>
        </div>
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-2"></div>
      <div class="col-12 md:col-6 lg:col-8">
        <div *ngFor="let msg of errMsgs">
          <p-message [severity]="msg.severity" [text]="msg.summary" [closable]="true"></p-message>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-2"></div>
    </div>
  </p-panel>
</div>